// import {Link} from 'react-router'
// import { Button } from 'wideeyes-ui'
import styles from './styles.css'
import React, { PropTypes } from 'react'
import {IndexLink, Link} from 'react-router'

const s = {
  list: {listStyle: 'none'},
  root: {paddingTop: '1rem', paddingBottom: '1rem', marginBottom: '1rem'}
}

const Header = ({logout}, {router, location}) =>
  <header className='col-xs-1-1' style={s.root}>
    <div className='row space-between v-center' style={s.root}>
      <div className='col-xs'>
        <img
          style={{
            maxWidth: 200,
            verticalAlign: 'middle',
            display: 'inline-block'
          }}
          src='https://s3-eu-west-1.amazonaws.com/wideeyes-assets/images/we_logo.png'
        />
      </div>
      <div className='col-xs'>
        <div className='row v-center'>
          <div className='col-xs'>
            <IndexLink
              to='/'
              className={styles.link}
              activeClassName={styles.active}
            >
              Home
            </IndexLink>
          </div>
          <div>
            <div className='separator' />
          </div>
          <div className='col-xs'>
            <Link
              to='/login'
              className={styles.logout}
              activeClassName={styles.active}
              onClick={e => {
                e.preventDefault()
                logout()
              }}
            >
              <span style={{fontSize: '1rem'}}>Logout <i className='fa fa-sign-out' /></span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </header>

Header.propTypes = {
  logout: PropTypes.func.isRequired
}

Header.contextTypes = {
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

module.exports = Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js